import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Users from './pages/Users';
import Projects from './pages/Projects';
import Sites from './pages/Sites';
import Sources from './pages/Sources';
import Map from './pages/Map';
import PlotRoute from './pages/PlotRoute';
import SGREForecastRoute from './pages/SGREForecastRoute';
import Dashboard from './pages/Dashboard';
import Heartbeats from './pages/Heartbeats';
import Navbar from './components/Navbar';
import { UserProvider } from './contexts/UserContext';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import darkTheme from './theme';

function App() {
    return (
        <ThemeProvider theme={darkTheme}>
            <CssBaseline />
            <UserProvider>
                <Router>
                    <Navbar />
                    <Routes>
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/heartbeats" element={<Heartbeats />} />
                        <Route path="/projects" element={<Projects />} />
                        <Route path="/sources" element={<Sources />} />
                        <Route path="/sites" element={<Sites />} />
                        <Route path="/users" element={<Users />} />
                        <Route path="/" element={<SGREForecastRoute />} />
                        <Route path="/plot" element={<PlotRoute />} />
                        <Route path="/sgre-forecast" element={<SGREForecastRoute />} />
                        <Route path="/map" element={<Map />} />
                    </Routes>
                </Router>
            </UserProvider>
        </ThemeProvider>
    );
}

export default App;
